import Axios from "axios";
import { BaseService } from "./BaseService";
import { Constantes } from "@/Util/Constantes";
import { AutoCompleteTemplate, Combo, Utilidades } from "@/Util/Utilidades";

BaseService.loadAxios();

export class ComboService {
    public static async getComboAsync(id: string, filter: string): Promise<Array<AutoCompleteTemplate>> {
        let autocomplete = new Array<Object>() as Array<AutoCompleteTemplate>;
        let combo = new Array<Object>() as Array<Combo>;

        await Axios.get(`${Constantes.RUTA_COMBO}/combo?id=${id}&filtro=${filter}`)
            .then(x => combo = x.data).catch((y) => {
                combo = [];
            });
        
        return Utilidades.CARGAR_COMBO_CON_HEADER(combo);
    }

    public static async getComboTextoAsync(id: string, filter: string, texto: string): Promise<Array<AutoCompleteTemplate>> {
        let autocomplete = new Array<Object>() as Array<AutoCompleteTemplate>;
        let combo = new Array<Object>() as Array<Combo>;
        texto = Utilidades.isNullOrUndefinedOrEmpty(texto) ? '' : texto;

        await Axios.get(`${Constantes.RUTA_COMBO}/combo?id=${id}&texto='${texto}'&filtro=${filter}`)
            .then(x => combo = x.data).catch((y) => {
                combo = [];
            });

        combo.forEach(x => { autocomplete.push(AutoCompleteTemplate.add({ text: x.texto, value: x.id, css: x.css_texto })) });

        return autocomplete;
    }

    public static async getComboRegistrarseAsync(id: string, filter: string): Promise<Array<AutoCompleteTemplate>> {
        let autocomplete = new Array<Object>() as Array<AutoCompleteTemplate>;
        let combo = new Array<Object>() as Array<Combo>;

        await Axios.get(`${Constantes.RUTA_COMBO}/registrarse/combo?id=${id}&filtro=${filter}`)
            .then(x => combo = x.data).catch((y) => {
                combo = [];
            });

        combo.forEach(x => { autocomplete.push(new AutoCompleteTemplate(x.texto, x.id)) });

        return autocomplete;
    }

    public static async getComboRaw(id: string, filter: string) {
        let response;

        await Axios.get(`${Constantes.RUTA_COMBO}/combo?id=${id}&filtro=${filter}`)
            .then(x => response = x)
            .catch((e) => {
                response = e?.response;
                response.data = [];
                response.error = e?.data;
            }
            );

        return response;

    }

    public static async getGrafica(id: string, filter = "" as string){
        let response; 

        await Axios.get(`/admin/grafica?id=${id}&filtro=${filter}`)
        .then(x => response = x)
        .catch((e) => {
            response = e?.response;
            response.data = [];
            response.error = e?.data;
        }
        );

         return Utilidades.cargarGrafica(response.data);
    }

    public static async getGraficaRaw(id: string, filter = "" as string){
        let response; 

        await Axios.get(`/admin/grafica?id=${id}&filtro=${filter}`)
        .then(x => response = x)
        .catch((e) => {
            response = e?.response;
            response.data = [];
            response.error = e?.data;
        }
        );

         return response;
    }
}